import * as user from './user'
import * as role from './role'
import * as administrator from './administrator'
import * as global from './global'
import * as config from './config'
import * as androidVersion from './androidVersion'
import * as conversation from './conversation'
import * as operate from './operate'
import * as system from './system'
import * as capital from './capital'
import * as binance from './binance'
import * as content from './content'
import * as trade from './trade'
import * as airdrop from './airdrop'
import * as expertAdvisor from './expertAdvisor'
import * as ethMaster from './ethMaster'
import * as Polygon from './Polygon'
import * as c2c from './c2c'

export default {
  user, // 用户相关api
  role, // 角色相关api
  administrator, // 管理员相关api
  global, // 通用模块api
  config, // 全局配置相关api
  androidVersion, // 安卓版本管理相关API
  conversation,
  operate,
  system,
  content,
  capital,
  binance,
  trade,
  airdrop,
  expertAdvisor,
  ethMaster,
  Polygon,
  c2c
}
